<div *ngIf="busy" class="busy-loading" [class.busy-loading--overlay]="overlay" aria-live="polite" aria-busy="true">
	<div class="busy-loading__spinner" aria-hidden="true"></div>
</div>
